<template>
    <div class="category-icon">
        <svg v-if="selected" width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M56 28.5C56 13.3122 43.6878 1 28.5 1C13.3122 1 1 13.3122 1 28.5C1 43.6878 13.3122 56 28.5 56V57C12.7599 57 0 44.2401 0 28.5C0 12.7599 12.7599 0 28.5 0C44.2401 0 57 12.7599 57 28.5C57 44.2401 44.2401 57 28.5 57V56C43.6878 56 56 43.6878 56 28.5Z"
                :fill="currentColor" />
            <path
                d="M28.5 6C40.9264 6 51 16.0736 51 28.5C51 40.9264 40.9264 51 28.5 51C16.0736 51 6 40.9264 6 28.5C6 16.0736 16.0736 6 28.5 6ZM28.5 20C23.8056 20 20 23.8056 20 28.5C20 33.1944 23.8056 37 28.5 37C33.1944 37 37 33.1944 37 28.5C37 23.8056 33.1944 20 28.5 20Z"
                :fill="currentColor" />
        </svg>
        <svg v-else width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M56 28.5C56 13.3122 43.6878 1 28.5 1C13.3122 1 1 13.3122 1 28.5C1 43.6878 13.3122 56 28.5 56V57C12.7599 57 0 44.2401 0 28.5C0 12.7599 12.7599 0 28.5 0C44.2401 0 57 12.7599 57 28.5C57 44.2401 44.2401 57 28.5 57V56C43.6878 56 56 43.6878 56 28.5Z"
                :fill="currentColor" />
            <path
                d="M50 28.5C50 16.6259 40.3741 7 28.5 7C16.6259 7 7 16.6259 7 28.5C7 40.3741 16.6259 50 28.5 50V51C16.0736 51 6 40.9264 6 28.5C6 16.0736 16.0736 6 28.5 6C40.9264 6 51 16.0736 51 28.5C51 40.9264 40.9264 51 28.5 51V50C40.3741 50 50 40.3741 50 28.5Z"
                :fill="currentColor" />
            <path
                d="M36 28.5C36 24.3579 32.6421 21 28.5 21C24.3579 21 21 24.3579 21 28.5C21 32.6421 24.3579 36 28.5 36V37C23.8056 37 20 33.1944 20 28.5C20 23.8056 23.8056 20 28.5 20C33.1944 20 37 23.8056 37 28.5C37 33.1944 33.1944 37 28.5 37V36C32.6421 36 36 32.6421 36 28.5Z"
                :fill="currentColor" />
        </svg>
        <div v-if="hasText" class="navbar-text-desc">
            <p>sound design</p>
        </div>
    </div>
</template>

<style scoped>
.category-icon {
    width: v-bind(width);
    height: v-bind(height);
    display: flex;
    gap: 14px;
}

svg {
    height: v-bind(height);
}

.navbar-text-desc p {
    width: 40px;
}
</style>

<script setup>
import { useThemeStore } from '@/stores/useThemeStore';
import { computed } from 'vue';

const currentColor = computed(() => (useThemeStore.isDark ? "#E8E8E8" : "#000000"))

const props = defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    hasText: {
        type: Boolean,
        default: false
    },
    width: {
        type: String,
        default: '153px'
    },
    height: {
        type: String,
        default: 'auto'
    }
})
</script>